import { katTranslator } from '../../shared/i18n';

// TODO - Update with other localizations
// https://sim.amazon.com/issues/KDS-2383
const strings = {
  kat_button_group_overflow_trigger_label: {
    'en-US': 'Show more',
    'fr-CA': 'Afficher plus',
    'fr-FR': 'Afficher plus',
    'ja-JP': 'すべて表示',
    'es-ES': 'Ver más',
    'es-MX': 'Mostrar más',
    'es-US': 'Mostrar más',
    'pt-PT': 'Mostrar mais',
    'zh-TW': '顯示更多',
    'tr-TR': 'Daha fazla göster',
    'de-DE': 'Weitere Optionen anzeigen',
    'nl-NL': 'Meer opties tonen',
    'pl-PL': 'Pokaż więcej',
    'ta-IN': 'மேலும் காண்பிக்கவும்',
    'mr-IN': 'अधिक दाखवा',
    'ml-IN': 'കൂടുതൽ കാണിക്കുക',
    'te-IN': 'మరిన్ని చూపించండి',
    'kn-IN': 'ಹೆಚ್ಚುನ್ನು ತೋರಿಸಿ',
    'sv-SE': 'Visa mer',
    'cs-CZ': 'Zobrazit další',
    'it-IT': 'Visualizza più dettagli',
    'pt-BR': 'Mostrar mais',
    'zh-CN': '显示更多',
    'ko-KR': '더 보기',
    'ar-AE': 'ظهار المزيد',
    'hi-IN': 'और दिखाएं',
    'bn-IN': 'আরো দেখান',
    'he-IL': 'הצג עוד',
  },
};

export default katTranslator(strings);
